import { styled } from "@mui/material"
import { Link as LinkRouter } from "react-router-dom"
import { palette } from "view/themes/palette"

export const GridHeader = styled("div")<{ $scrollWidth: number }>(
  ({ $scrollWidth }) => ({
    width: `calc(100% + ${$scrollWidth}px - 12px)`,
    backgroundColor: palette.grey50,
    display: "flex",
    height: 40,
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 16,
    color: palette.grey500,
    marginBottom: 8,
    boxSizing: "border-box",
  })
)

export const GridHeaderItem = styled("div")<{
  $maxWidth: number
  $minWidth: number
}>(({ $maxWidth, $minWidth }) => ({
  padding: "0 12px",
  display: "flex",
  alignItems: "center",
  width: "100%",
  maxWidth: `${$maxWidth}px`,
  minWidth: `${$minWidth}px`,
}))

export const GridListEmpty = styled("div")(() => ({
  width: "100%",
  height:
    "calc(100vh - 72px - 24px - 24px - 32px - 16px - 16px - 32px - 8px - 40px - 10px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: palette.grey500,
  fontSize: 13,

  "& div": {
    paddingBottom: 80,
  },
}))

export const GridList = styled("div")<{ $scrollWidth: number }>(
  ({ $scrollWidth }) => ({
    width: `calc(100% + ${$scrollWidth}px)`,
    maxHeight:
      "calc(100vh - 72px - 24px - 24px - 32px - 16px - 16px - 32px - 8px - 40px - 10px)",
    overflowY: "auto",
    scrollbarGutter: "stable",
  })
)

export const GridListRow = styled("div")<{ $isActive?: boolean }>(
  ({ $isActive }) => ({
    borderTop: `1px dotted ${palette.grey300}`,
    height: 48,
    display: "flex",
    alignItems: "center",
    backgroundColor: `${$isActive ? palette.info100 : "none"}`,
  })
)

export const GridListColumn = styled(GridHeaderItem)(
  ({ $maxWidth, $minWidth }) => ({
    padding: "0 12px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: 13,
    maxWidth: `${$maxWidth}px`,
    minWidth: `${$minWidth}px`,
    display: "flex",
    alignItems: "center",
  })
)

export const Link = styled(LinkRouter)(() => ({
  color: palette.info500,
  textDecoration: "none",

  "&:hover": {
    textDecoration: "underline",
  },
}))

export const CopyIcon = styled("div")(() => ({
  marginLeft: 8,
  display: "flex",
  alignItems: "center",
  cursor: "pointer",

  "&:hover": {
    svg: {
      path: {
        stroke: palette.info500,
      },
      rect: {
        stroke: palette.info500,
      },
    },
  },
}))
